var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, } from 'react';
import classNames from 'classnames';
import { Clear } from './Clear';
import { Submit } from './Submit';
import styles from './SearchBox.module.scss';
var SearchBox = function (_a) {
    var _b;
    var ariaActivedescendant = _a.ariaActivedescendant, ariaAutocomplete = _a.ariaAutocomplete, ariaOwns = _a.ariaOwns, ariaTitle = _a.ariaTitle, children = _a.children, className = _a.className, focus = _a.focus, formRef = _a.formRef, id = _a.id, initialValue = _a.initialValue, _c = _a.inputProps, inputProps = _c === void 0 ? {} : _c, _d = _a.onChange, onChange = _d === void 0 ? function () { return undefined; } : _d, _e = _a.onClearClick, onClearClick = _e === void 0 ? function () { return undefined; } : _e, _f = _a.onSubmit, onSubmit = _f === void 0 ? function () { return undefined; } : _f, _g = _a.placeholder, placeholder = _g === void 0 ? '' : _g, role = _a.role, value = _a.value;
    var _h = useState(false), typing = _h[0], setTyping = _h[1];
    useEffect(function () {
        if (value !== initialValue || !value)
            setTyping(!!value);
    }, [initialValue, value]);
    useEffect(function () {
        setTyping(false);
    }, [initialValue]);
    return (React.createElement("form", { "aria-label": "".concat(ariaTitle ? "".concat(ariaTitle, " s") : ' S', "earch form"), className: classNames(styles.form, className), "data-testid": "search-form", id: id || 'search-form', onSubmit: function (e) {
            e.preventDefault();
            setTyping(false);
            onSubmit(e);
        }, ref: formRef, role: "search" },
        React.createElement("div", { className: classNames(styles.border, (_b = {},
                _b[styles.active] = focus,
                _b)) },
            React.createElement("input", __assign({ "aria-activedescendant": focus ? ariaActivedescendant : undefined, "aria-autocomplete": ariaAutocomplete, "aria-label": "".concat(ariaTitle ? "".concat(ariaTitle, " ") : '', "Search: ").concat(value), "aria-owns": focus ? ariaOwns : undefined, autoComplete: "off", className: classNames(styles.input), "data-element": "search-term", onChange: onChange, placeholder: placeholder, role: role, type: "text", value: value }, inputProps)),
            React.createElement("div", { className: classNames(styles.submit) },
                // Example children are multisearch, auto-suggest components.
                children,
                React.createElement(Clear, { hidden: value.length === 0, onClick: onClearClick }),
                React.createElement(Submit, { active: typing })))));
};
export { SearchBox };
//# sourceMappingURL=SearchBox.js.map